/** Accueil : présentation et choix du rôle. */

import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { StoreElement } from '../base.js';
import { icone } from '../icons.js';

@customElement('view-home')
export class ViewHome extends StoreElement {
  override render() {
    return html`
      <div class="page">
        <header class="stack stack--tight prose">
          <span class="eyebrow">${icone('checkCercle', 17)} Élection des délégués de classe</span>
          <h1 class="t-display">Deux délégués, deux suppléants, deux tours.</h1>
          <p class="t-body t-muted">
            Le scrutin se déroule entièrement dans le navigateur : aucune donnée ne quitte l’établissement, et rien
            ne dépend d’un serveur central ni d’une base de données.
          </p>
        </header>

        <nav class="roles" aria-label="Choix du rôle">
          <a class="role" href="#/bureau">
            <span class="role__icon" aria-hidden="true">${icone('ecole', 26)}</span>
            <span class="role__texte">
              <span class="t-title">Je suis l’enseignant</span>
              <span class="t-body t-muted">
                Créer l’élection, imprimer les codes, valider les candidatures, dépouiller et proclamer.
              </span>
            </span>
            <span class="role__chev" aria-hidden="true">${icone('chevron', 22)}</span>
          </a>

          <a class="role" href="#/vote">
            <span class="role__icon" aria-hidden="true">${icone('vote', 26)}</span>
            <span class="role__texte">
              <span class="t-title">Je vote</span>
              <span class="t-body t-muted">
                Saisir le code projeté par le professeur, puis mon code personnel. Le vote reste secret.
              </span>
            </span>
            <span class="role__chev" aria-hidden="true">${icone('chevron', 22)}</span>
          </a>

          <a class="role" href="#/affichage">
            <span class="role__icon" aria-hidden="true">${icone('affichage', 26)}</span>
            <span class="role__texte">
              <span class="t-title">Affichage</span>
              <span class="t-body t-muted">
                Vue à vidéoprojeter : phase en cours, participation, résultats en direct.
              </span>
            </span>
            <span class="role__chev" aria-hidden="true">${icone('chevron', 22)}</span>
          </a>
        </nav>

        <section class="card card--flat">
          <div class="card__head">
            <span class="chip-icon chip-icon--doux" aria-hidden="true">${icone('info', 22)}</span>
            <h2 class="t-title">Conformité</h2>
          </div>
          <p class="t-body">
            Règles établies d’après la fiche
            <a href="https://www.service-public.gouv.fr/particuliers/vosdroits/F1370" rel="noreferrer noopener" target="_blank"
              >Délégués de classe (F1370)</a
            >. Premier tour à la majorité absolue des bulletins valides, second tour à la majorité relative. Toute
            situation imprévue peut être tranchée par une décision souveraine de l’enseignant, consignée au
            procès-verbal.
          </p>
        </section>
      </div>
    `;
  }
}
